import type { CardFieldOption, CardResourceKind } from './types';

export interface CardResourceContext {
	devices?: Record<string, any>;
	rooms?: Record<string, any> | any[];
	zones?: Array<{ id: string | number; name?: string; title?: string }>;
	scenes?: Record<string, any> | any[];
	groups?: Record<string, any> | any[];
	scripts?: Array<{ id: string | number; name?: string; title?: string }>;
}

function values(source: Record<string, any> | any[] | undefined): any[] {
	return Array.isArray(source) ? source : Object.values(source || {});
}

function resourceId(entry: any): string | number | undefined {
	return entry?.id ?? entry?._id ?? entry?.value;
}

function resourceLabel(entry: any): string {
	return String(
		entry?.name || entry?.title || entry?.label || entry?._meta?.name || resourceId(entry) || '',
	);
}

function isAlarm(entry: any): boolean {
	return (
		entry?._gui_function === 'alarm' ||
		entry?._meta?.extra === 'alarm' ||
		resourceLabel(entry).toLowerCase().includes('alarm')
	);
}

export function resolveCardResourceOptions(
	kind: CardResourceKind,
	context: CardResourceContext,
	filter?: 'scene' | 'alarm' | ((entry: any) => boolean),
): CardFieldOption[] {
	const source =
		kind === 'device'
			? values(context.devices)
			: kind === 'room'
				? values(context.rooms)
				: kind === 'zone'
					? context.zones || []
					: kind === 'scene'
						? values(context.scenes)
						: kind === 'group'
							? values(context.groups)
							: context.scripts || [];
	return source
		.filter((entry) => entry && resourceId(entry) != null)
		.filter((entry) => {
			if (!filter) return true;
			if (typeof filter === 'function') return filter(entry);
			return filter === 'alarm' ? isAlarm(entry) : !isAlarm(entry);
		})
		.map((entry) => ({
			value: resourceId(entry)!,
			label: resourceLabel(entry),
			...(entry.type || entry._gui_function || entry._meta?.extra
				? { resourceType: String(entry.type || entry._gui_function || entry._meta?.extra) }
				: {}),
		}));
}
